import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PrevArrow = props => {
  const { onClick } = props;
  return (
    <span
      data-role="none"
      className="slider-control left template-arrow-left-1"
      aria-label="Previous"
      style={{ display: 'block' }}
      onClick={onClick}
    >
      <i className="fa fa-angle-left" />
    </span>
  );
};

const NextArrow = props => {
  const { onClick } = props;
  return (
    <span
      data-role="none"
      className="slider-control right template-arrow-left-1"
      aria-label="Next"
      style={{ display: 'block' }}
      onClick={onClick}
    >
      <i className="fa fa-angle-right" />
    </span>
  );
};

const SimpleSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    fade: true,
  };

  return (
    <Slider {...settings}>
      <li className="slide">
        <div className="hexagon small">
          <div className="sl-small-person" />
        </div>
        <p>
          "Po ponad pół roku użerania się z moim samochodem jeżdżąc po różnych mechanikach, bardzo dziękuje Luk&Luk Auto
          Serwis a zwłaszcza Panu Dawidowi który informował mnie na bieżąco co jest zepsute oraz wysyłał zdjęcia co
          trzeba zrobić . <br />
          Od 3 miesięcy mogę teraz śmiało powiedzieć że BMW daje radość z jazdy a ludzie pracujący w tym Serwisie w
          zupełności są profesjonalistami , począwszy od obsługi klienta aż do mechaników a co w tej branży jest już
          niestety mało spotykane ."
        </p>
        <h6>Patryk</h6>
      </li>
      <li className="slide">
        <div className="hexagon small">
          <div className="sl-small-person" />
        </div>
        <p>
          "Fachowa obsługa, szczerze mówiąc mam wrażenie, że bardziej fachowa niż w punktach ASO, samochód sprawdzono w
          szczegółach , czynności serwisowe wykonano na najwyższym poziomie. Szczerze polecam wszystkim"
        </p>
        <h6>Radosław</h6>
      </li>
      <li className="slide">
        <div className="hexagon small">
          <div className="sl-small-person" />
        </div>
        <p>
          "Luk&Luk to najlepszy warsztat w okolicy z fachową obsługą i najwyższą jakością wykonywanych usług. Diagnoza
          przeprowadzona szybko, a problem rozwiązany starannie.<br />
          Rozmowy na temat, bez machlojek i robienia przysłowiowego "debila" z klienta, co jest dzisiaj rzadko spotykaną
          cechą w warsztatach samochodowych. Wszystkie potrzebne części do naprawy na miejscu, cena usługi
          konkurencyjna. Samochód wydaje się być zadowolony z wizyty w tym warsztacie:) Polecam z czystym sumieniem!"
        </p>
        <h6>Kasia</h6>
      </li>
    </Slider>
  );
};

export default SimpleSlider;



// WEBPACK FOOTER //
// ./src/components/Slider.js